import { useDispatch, useSelector } from 'react-redux';

import {
  getCompanies,
  updateOrCreateRequest,
  getByIdRequest,
  resetCurrentItem,
  deleteCompany,
  resetErrors,
} from './actions';
import {
  companiesListData,
  companiesListLoading,
  companiesListFetched,
  companiesUpdateOrCreateInProcess,
  companiesCurrentItem,
  companiesCurrentItemLoading,
  deleteInProcessSelector,
  companiesCurrentItemErrors,
} from './selectors';
import { useHistory } from 'react-router-dom';

export const useCompany = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listData = useSelector(companiesListData);
  const listLoading = useSelector(companiesListLoading);
  const listFetched = useSelector(companiesListFetched);
  const inProcess = useSelector(companiesUpdateOrCreateInProcess);
  const currentItem = useSelector(companiesCurrentItem);
  const currentItemLoading = useSelector(companiesCurrentItemLoading);
  const deleteInProcess = useSelector(deleteInProcessSelector);
  const errors = useSelector(companiesCurrentItemErrors);

  const handleFetchInitialList = () => {
    if (!listFetched) {
      dispatch(getCompanies({}));
    }
  };

  const updateOrCreate = (payload) => {
    dispatch(updateOrCreateRequest({ ...payload, history }));
  };

  const handleGetById = (id) => {
    dispatch(getByIdRequest({ id }));
  };

  const handleResetCurrentItem = () => {
    dispatch(resetCurrentItem());
  };

  const handleDeleteCompany = (id) => {
    dispatch(deleteCompany({ id, history }));
  };

  const handleResetErrors = () => {
    if (errors) {
      dispatch(resetErrors());
    }
  };

  return {
    listData,
    listLoading,
    handleFetchInitialList,
    inProcess,
    updateOrCreate,
    handleGetById,
    currentItem,
    currentItemLoading,
    handleResetCurrentItem,
    handleDeleteCompany,
    deleteInProcess,
    errors,
    handleResetErrors,
  };
};
